// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getStaffTeamById } from 'app/constants/enums/StaffTeam/main';

/* eslint-disable max-len */
export const CORPORATE_SALES_TEAM = getStaffTeamById('corporateSales');
export const ENGOO_INTERNATIONAL_CUSTOMER_SUPPORT_TEAM = getStaffTeamById('engooInternationalCustomerSupport');
export const JAPAN_CUSTOMER_SUPPORT_TEAM = getStaffTeamById('japanCustomerSupport');
export const KOREA_CUSTOMER_SUPPORT_TEAM = getStaffTeamById('koreaCustomerSupport');
export const MATERIALS_TEAM = getStaffTeamById('materials');
export const PH_DEV_TEAM = getStaffTeamById('phDev');
export const RECRUITMENT_TEAM = getStaffTeamById('recruitment');
export const TAIWAN_CUSTOMER_SUPPORT_TEAM = getStaffTeamById('taiwanCustomerSupport');
export const TESTING_TEAM = getStaffTeamById('testing');
export const THAILAND_CUSTOMER_SUPPORT_TEAM = getStaffTeamById('thailandCustomerSupport');
export const TOKYO_DEV_TEAM = getStaffTeamById('tokyoDev');
export const TUTOR_PAYROLL_TEAM = getStaffTeamById('tutorPayroll');
export const TUTOR_SUPPORT_TEAM = getStaffTeamById('tutorSupport');
/* eslint-enable max-len */
